export interface IUserList {
  binusianId: string;
  name: string;
  email: string;
  department: string;
  title: string;
  leader: string;
  roleName: string;
  businessUnit: string;
}

export namespace IUserList {
  export function fromJSON(data: { [key: string]: any }): IUserList {
    return {
      binusianId: data.binusianID,
      name: data.binusianName,
      email: data.email,
      department: data.department,
      title: data.title,
      leader: data.buLeader,
      roleName: data.roleName,
      businessUnit: data.businessUnit,
    };
  }
}
